/* script */
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { MESSAGE_RECEIVE, MESSAGE_SEND } from '../../../../frontend/model/contracts/shared/constants.js'
import isPwa from '../../../../frontend/utils/isPwa.js'

const __vue_script__ = ({
  name: 'BackgroundSounds',
  created () {
    sbp('okTurtles.events/on', MESSAGE_RECEIVE, this.playMessageReceive)
    sbp('okTurtles.events/on', MESSAGE_SEND, this.playMessageSend)
  },
  computed: {
    volumeFromStore () {
      return this.$store.getters.notificationVolume ?? 1 // The volume value in the store can be 0 too and we use it if that's the case.
    },
    isAppIdle () {
      // NOTE: idle-vue plugin will provide this.isAppIdle
      //       but sometimes it returns undefined, so redefine here
      return this.$store.state.idleVue?.isIdle || false
    }
  },
  methods: {
    shouldPlay (contractID) {
      if (isPwa()) { return false }

      // document.hidden - when current tab is not active
      // document.hasFocus() - There is a case where current tab is open but the browser window itself is not in focus(In the background).
      //                       document.hasFocus() is used to catch this kind of case.
      const isTabInactive = document.hidden || !document.hasFocus()
      // Check if the app is showing the target chatroom now.
      const isViewingThisChatroom = contractID &&
        this.$route.name === 'GroupChatConversation' &&
        this.$route.params.chatRoomID === contractID

      // There are 3 cases where we want to play the sound:
      // 1) The current tab is inactive.
      // 2) The current tab is active but not showing the chatroom.
      // 3) The current tab is active and showing the chatroom but the app has been idle for a while.
      return (
        isTabInactive ||
        !isViewingThisChatroom ||
        this.isAppIdle
      )
    },
    playMessageReceive ({ contractID }   
                         
                          
                         
     ) {
      if (this.shouldPlay(contractID)) {
        this.$refs.msgReceive.play()
      }
    },
    playMessageSend ({ contractID } = {}) {
      if (this.shouldPlay(contractID)) {
        this.$refs.msgSend.play()
      }
    },
    updateAudioVolumes () {
      this.$refs.msgReceive.volume = this.volumeFromStore
      this.$refs.msgSend.volume = this.volumeFromStore
    }
  },
  mounted () {
    this.updateAudioVolumes()
  },
  watch: {
    volumeFromStore () {
      // Update the audio elements accordingly when the volume change in the store is detected.
      this.updateAudioVolumes()
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-bgsound-wrapper" }, [
    _c("audio", {
      ref: "msgReceive",
      attrs: { src: "/assets/audio/msg-received.mp3", type: "audio/mpeg" },
    }),
    _c("audio", {
      ref: "msgSend",
      attrs: { src: "/assets/audio/msg-sent.mp3", type: "audio/mpeg" },
    }),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-147eb01e_0", { source: "\n\n/*# sourceMappingURL=Background.vue.map */", map: {"version":3,"sources":["Background.vue"],"names":[],"mappings":";;AAEA,yCAAyC","file":"Background.vue","sourcesContent":["\n\n/*# sourceMappingURL=Background.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-147eb01e"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n.c-bgsound-wrapper\n  audio(ref='msgReceive' src='/assets/audio/msg-received.mp3' type='audio/mpeg')\n  audio(ref='msgSend' src='/assets/audio/msg-sent.mp3' type='audio/mpeg')\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { MESSAGE_RECEIVE, MESSAGE_SEND } from '../../../../frontend/model/contracts/shared/constants.js'\nimport isPwa from '../../../../frontend/utils/isPwa.js'\n\nexport default ({\n  name: 'BackgroundSounds',\n  created () {\n    sbp('okTurtles.events/on', MESSAGE_RECEIVE, this.playMessageReceive)\n    sbp('okTurtles.events/on', MESSAGE_SEND, this.playMessageSend)\n  },\n  computed: {\n    volumeFromStore () {\n      return this.$store.getters.notificationVolume ?? 1 // The volume value in the store can be 0 too and we use it if that's the case.\n    },\n    isAppIdle () {\n      // NOTE: idle-vue plugin will provide this.isAppIdle\n      //       but sometimes it returns undefined, so redefine here\n      return this.$store.state.idleVue?.isIdle || false\n    }\n  },\n  methods: {\n    shouldPlay (contractID) {\n      if (isPwa()) { return false }\n\n      // document.hidden - when current tab is not active\n      // document.hasFocus() - There is a case where current tab is open but the browser window itself is not in focus(In the background).\n      //                       document.hasFocus() is used to catch this kind of case.\n      const isTabInactive = document.hidden || !document.hasFocus()\n      // Check if the app is showing the target chatroom now.\n      const isViewingThisChatroom = contractID &&\n        this.$route.name === 'GroupChatConversation' &&\n        this.$route.params.chatRoomID === contractID\n\n      // There are 3 cases where we want to play the sound:\n      // 1) The current tab is inactive.\n      // 2) The current tab is active but not showing the chatroom.\n      // 3) The current tab is active and showing the chatroom but the app has been idle for a while.\n      return (\n        isTabInactive ||\n        !isViewingThisChatroom ||\n        this.isAppIdle\n      )\n    },\n    playMessageReceive ({ contractID }: {\n      contractID: string,\n      messageHash: string,\n      messageType: string\n    }) {\n      if (this.shouldPlay(contractID)) {\n        this.$refs.msgReceive.play()\n      }\n    },\n    playMessageSend ({ contractID } = {}) {\n      if (this.shouldPlay(contractID)) {\n        this.$refs.msgSend.play()\n      }\n    },\n    updateAudioVolumes () {\n      this.$refs.msgReceive.volume = this.volumeFromStore\n      this.$refs.msgSend.volume = this.volumeFromStore\n    }\n  },\n  mounted () {\n    this.updateAudioVolumes()\n  },\n  watch: {\n    volumeFromStore () {\n      // Update the audio elements accordingly when the volume change in the store is detected.\n      this.updateAudioVolumes()\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__